var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;


//////////////////
// WEBPACK FOOTER
// /home/gitlab-runner/builds/_opy_VqP/0/cw/ws/uvocorp.com/gatsby/~/string-convert/camel2hyphen.js
// module id = 514
// module chunks = 35783957827783